import React, { FC, ReactNode, ElementType } from 'react';

interface Props {
  className?: string;
  children: ReactNode;
  // Don't want padding? Pass in your own style property
  style?: Record<string, string>;
  tag?: ElementType;

  onClick?: () => void;
}

// TODO: Handle different elevations / shadow options
// TODO: Get shadow style from theme? (could make shadow color based on primary brand color / easier on eyes)
const Card: FC<Props> = ({ children, className, onClick, style = {}, tag = 'div', ...props }) => {
  const Tag = tag;
  return (
    <Tag className={className} style={style} onClick={onClick} {...props}>
      {children}
    </Tag>
  );
};

export default React.memo(Card);
